import crypto from 'crypto-js/hmac-md5'

export const getRelativeUrl = (url) => {
  return '/' + url.replace(/^(?:\/\/|[^\/]+)*\//, '')
}

export const decodeHTML = (html) => {
  if (typeof window === 'undefined') return html
  const txt = document.createElement('textarea')
  txt.innerHTML = html
  return txt.value
}

export const mobileCheck = () => {
  let check = false
  if (typeof window !== 'undefined') {
    ;(function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true
    })(navigator.userAgent || navigator.vendor || window.opera)
  }

  return check
}

/*Count object length*/
export const objectSize = (obj) => Object.keys(obj).length

export const inArray = (needle, stack = []) => {
  if (typeof needle === 'undefined') return false
  return stack.includes(needle)
}

/*Safe Return*/
export const safeReturn = (obj, key, defaultValue, checkFor) => {
  defaultValue = typeof defaultValue === 'undefined' ? false : defaultValue
  if (
    typeof obj === 'undefined' ||
    typeof key === 'undefined' ||
    obj === null ||
    key === null
  ) {
    return defaultValue
  }

  if (obj.hasOwnProperty(key) === false) {
    return defaultValue
  }
  if (inArray(null, checkFor) && obj[key] === null) {
    return defaultValue
  }
  if (inArray('', checkFor) && obj[key] === '') {
    return defaultValue
  }
  if (inArray('0', checkFor) && obj[key] === '0') {
    return defaultValue
  }
  return obj[key]
}

/*read cookie*/
export const readCookie = (name, str = '') => {
  if (
    (typeof window !== 'undefined' && document.cookie) ||
    (typeof window === 'undefined' && str)
  ) {
    const nameEQ = name + '='
    const ca =
      typeof window !== 'undefined'
        ? document.cookie.split(';')
        : str.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
  }

  return null
}

export const offset = (el) => {
  if (typeof window !== 'undefined' && el !== null) {
    const rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop

    return {
      top: rect.top + scrollTop,
      left: rect.left + scrollLeft,
      viewPortTop: rect.top
    }
  } else {
    return false
  }
}

export const getUrlParameter = (name) => {
  if (typeof window !== 'undefined') {
    const escapedName = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
    const regex = new RegExp('[\\?&]' + escapedName + '=([^&#]*)')
    const results = regex.exec(window.location.search)
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '))
  } else {
    return ''
  }
}

export const spu_createCookie = (name, value, hours) => {
  if (!hours) {
    hours = 8760
  }

  const date = new Date()
  date.setTime(date.getTime() + hours * 60 * 60 * 1000)
  const expires = '; expires=' + date.toGMTString()

  document.cookie = name + '=' + value + expires + '; path=/'
}

export const myIsSet = (obj, key, checkNull = false, checkEmpty = false) => {
  if (typeof obj === 'undefined') {
    return false
  }

  const keys = key.split('.')
  if (keys.length === 0) {
    return false
  }

  for (const k of keys) {
    if (obj !== null && obj.hasOwnProperty(k)) {
      obj = obj[k]
    } else {
      return false
    }
  }

  if (checkNull === true && obj === null) {
    return false
  }

  if (checkEmpty === true && obj === '') {
    return false
  }

  return true
}

export const getScrollPostion = () => {
  if (typeof window === 'undefined') return 0
  return (
    window.scrollY ||
    window.pageYOffset ||
    document.body.scrollTop +
      ((document.documentElement && document.documentElement.scrollTop) || 0)
  )
}

export const jsUcfirst = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/*Append Resize key*/
export const appendResizeKey = (link, sizeW = '', sizeH = '') => {
  if (!sizeW && !sizeH) return link
  const h = sizeH !== '' && sizeW !== '' ? '&h' : 'h'
  return (
    link +
    '?resize=' +
    (sizeW !== '' ? 'w' + sizeW : '') +
    (sizeH !== '' ? h + sizeH : '')
  )
}

/*#lazyLoadImage*/
export const lazyLoadImage = (dataIslazyUrl = 'data-islazy') => {
  const imageDiv = document.querySelectorAll(`[${dataIslazyUrl}]`)
  for (let i = 0; i < imageDiv.length; i++) {
    const lazyUrl = imageDiv[i].getAttribute(dataIslazyUrl)
    if (!lazyUrl) continue

    if (
      imageDiv[i].tagName.toLowerCase() === 'img' ||
      imageDiv[i].tagName.toLowerCase() === 'iframe'
    ) {
      imageDiv[i].src = lazyUrl
      imageDiv[i].removeAttribute(dataIslazyUrl)
    } else {
      const img = new Image()
      img.onload = (function (el, url) {
        return function () {
          el.style['background-image'] = `url(${url})`
          el.removeAttribute(dataIslazyUrl)
        }
      })(imageDiv[i], lazyUrl)
      img.src = lazyUrl
    }
  }
}

export const lazyLoadScript = (url, callback) => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  if (callback) {
    script.onload = function () {
      callback()
    }
  }

  script.src = url
  document.getElementsByTagName('head')[0].appendChild(script)
}

export const serverNow = () => {
  const ts = process.hrtime()
  return ts[0] * 1e3 + ts[1] / 1e6
}

export const setUrlParameter = (url, params) => {
  const path = url.split('?')
  const vars = path[1] ? path[1].split('&').filter(Boolean) : []

  for (const i in params) {
    const newParam = `${params[i]}`
    const newKey = newParam.split('=')[0]
    const index = vars.findIndex((v) => v.split('=')[0] === newKey)
    if (index !== -1) {
      vars[index] = newParam
    } else {
      vars.push(newParam)
    }
  }

  let slug = vars.length !== 0 ? path[0] + '?' + vars.join('&') : url
  slug = slug.replace('?&', '?').replace('??', '?')

  return slug
}

export const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1]
    if (!base64Url) return null
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload =
      typeof window !== 'undefined'
        ? decodeURIComponent(
            atob(base64)
              .split('')
              .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
              .join('')
          )
        : Buffer.from(base64, 'base64').toString('utf8')
    return JSON.parse(jsonPayload)
  } catch {
    return null
  }
}

export const gtmSend = (
  event,
  category,
  action,
  label,
  value = 1,
  params = {}
) => {
  if (typeof window !== 'undefined') {
    if (
      process.env.RAZZLE_SITE === 'community' ||
      process.env.REACT_SITE_TYPE === 'community_web'
    ) {
      event = event === 'dynamic' ? 'dynamic event' : event
    } else {
      event = event === 'dynamic' ? 'Dynamic GTM Event' : event
    }

    if (process.env.REACT_APP_COMMUNITY_API_ENV !== 'production') {
      console.info(
        'GTM Event:',
        event,
        ' | ',
        category,
        ' | ',
        action,
        ' | ',
        label,
        ' | ',
        value,
        ' | ',
        params
      )
    }

    if (process.env.REACT_APP_COMMUNITY_API_ENV !== 'development') {
      if (window.dataLayer) {
        const toPush = {
          event: event,
          eventValue: value
        }
        if (category) toPush['eventCategory'] = category
        if (action) toPush['eventAction'] = action
        if (label) toPush['eventLabel'] = label

        //params
        for (const k in params) {
          toPush[k] = params[k]
        }
        //console.info(window.dataLayer, toPush);
        window.dataLayer.push(toPush)
      }
    }
  }
}

export const setDefaultEnvObj = (
  user,
  timeout = '',
  env = '',
  request = {},
  authorizationType = 'default'
) => {
  const obj = {
    env: process.env.RAZZLE_TAP_API_ENV,
    timeout: typeof window !== 'undefined' ? 60000 : 5000
  }

  if (
    process.env.RAZZLE_SITE === 'vip_web' ||
    process.env.RAZZLE_SITE === 'vip_admin'
  ) {
    obj['env'] = process.env.RAZZLE_VIP_API_ENV
  }

  if (process.env.REACT_APP_SITE_TYPE === 'community_web') {
    obj['env'] = process.env.REACT_APP_COMMUNITY_API_ENV
  }
  if (timeout) {
    obj['timeout'] = timeout
  }

  if (env) {
    obj['env'] = env
  }

  if (process.env.REACT_SITE_TYPE !== 'community_web') {
    obj['headers'] = setApiHeaderObj(user, request, authorizationType)
  }

  return obj
}

// TODO: MD5 HMAC is cryptographically weak — migrate to HMAC-SHA256 when the backend API supports it
const getBackendApiAuthorization = (salt, secret) => {
  let dt = new Date()
  dt = `${dt.getUTCDate()}-${dt.getUTCMonth()}-${dt.getUTCFullYear()}`
  const hmac = crypto(`${secret}-${dt}`, salt)
  return hmac.toString()
}

//authorizationType: default | cookie | gtap | md5
const setApiHeaderObj = (
  userObj,
  request = {},
  authorizationType = 'default'
) => {
  const apiHeaders = {}

  //This condition for testing app screens on web
  if (process.env.RAZZLE_REACT_APP_ENV === 'development') {
    if (authorizationType === 'gtap' || userObj?.routerObj?.isAppScreen) {
      apiHeaders['Authorization'] = process.env.REACT_APP_DEV_BEARER_TOKEN
        ? `Bearer ${process.env.REACT_APP_DEV_BEARER_TOKEN}`
        : undefined
    } else {
      if (
        process.env.RAZZLE_SITE === 'vip_web' ||
        process.env.RAZZLE_SITE === 'vip_admin'
      ) {
        apiHeaders['Authorization'] = getBackendApiAuthorization(
          process.env.RAZZLE_VIP_API_SALT,
          process.env.RAZZLE_VIP_API_SECRET
        )
      }

      if (
        (process.env.RAZZLE_SITE === 'tap' ||
          process.env.RAZZLE_SITE === 'community') &&
        userObj?.profile?.token
      ) {
        apiHeaders['Authorization'] = userObj.profile.token
      }
    }
  } else {
    if (typeof window !== 'undefined') {
      //Attach Authorization in API header for API validation on mobile
      if (
        userObj?.profile?.token &&
        (userObj?.routerObj?.isAppScreen ||
          authorizationType === 'gtap' ||
          process.env.RAZZLE_SITE === 'tap' ||
          process.env.RAZZLE_SITE === 'community')
      ) {
        apiHeaders['Authorization'] = userObj.profile.token
      }
    } else {
      //Attach cookie in API header for API validation on node
      if (userObj?.serverReqCookie) {
        apiHeaders['Cookie'] = userObj.serverReqCookie
      }

      if (authorizationType === 'default') {
        //Attach Authorization in API header for API validation on mobile
        if (
          request?.headers?.authorization &&
          userObj?.routerObj?.isAppScreen
        ) {
          apiHeaders['Authorization'] = request.headers.authorization
        } else {
          if (process.env.RAZZLE_SITE === 'tap' && userObj?.profile?.token) {
            apiHeaders['Authorization'] = userObj.profile.token
          }
        }
      } else if (authorizationType === 'gtap') {
        if (userObj?.profile?.token) {
          apiHeaders['Authorization'] = userObj.profile.token
        }
      }
    }
  }

  return apiHeaders
}

export const debounce = (func, timeout = 200) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(null, args)
    }, timeout)
  }
}

export const generateAssetCdnUrl = (
  bucketName,
  fileName,
  assetSizeParams = {}
) => {
  const assetCdnDomain = 'https://static.cdntap.com/'
  if (!bucketName) return assetCdnDomain

  if (Object.keys(assetSizeParams).length > 0) {
    const optimizeSizeParams = []
    for (const [key, value] of Object.entries(assetSizeParams)) {
      optimizeSizeParams.push(`${key}=${value}`)
    }

    return `${assetCdnDomain}${bucketName}/${fileName}?${optimizeSizeParams.join('&')}`
  }

  return `${assetCdnDomain}${bucketName}${fileName ? '/' + fileName : ''}`
}
